import {Component, OnInit, Input} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NewAccessCardService} from '../service/new-access-card.service';
import {NgxSpinnerService} from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ModErrorComponent} from '../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-new-cards-result',
  templateUrl: './new-cards-result.component.html'
})

export class NewCardsResultComponent implements OnInit {
  @Input() id: string;
  @Input() status: string;
  card: any;

  constructor(private route: ActivatedRoute,
              private dataApi: NewAccessCardService,
              private spinner: NgxSpinnerService,
              private _snackBar: MatSnackBar,
              public dialog: MatDialog) {
    this.route.snapshot.paramMap.get('id');
    this.id = this.route.snapshot.paramMap.get('id');
  }

  getCardResult() {
    this.spinner.show('loading');
    this.dataApi.getCardResult(this.id).subscribe((data: any) => {
      this.card = data;
      this.spinner.hide('loading');

    }, (err) => {
      this.spinner.hide('loading');
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
      }

    });
  }


  ngOnInit() {
    this.getCardResult();
  }
}
